import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [['01', 'Banco de Evaluaciones y Rúbricas de Historia', '15', 'Evaluaciones listas con distintos niveles de dificultad y rúbricas alineadas a los temas del pack. Diagnósticas, formativas, integradoras y de cierre para cada período histórico.', 'Ahorra horas en cada trimestre.'], ['02', 'Glosario Completo de Términos Históricos', '12', 'Todos los términos clave de la historia explicados de forma clara y listos para entregar directamente a tus alumnos. Desde “feudalismo” hasta “neoliberalismo”, todo definido con precisión y lenguaje accesible.', 'Recupera tiempo de clase.'], ['03', 'Manual de Respuestas para Preguntas Difíciles', '10', 'La respuesta correcta para las preguntas históricas que más ponen a prueba tu seguridad frente al grupo. Las preguntas complejas sobre procesos, interpretaciones y debates históricos, resueltas con claridad.', 'Nunca más un silencio incómodo.'], ['04', 'Líneas del Tiempo Completas', '9', 'Líneas del tiempo listas para proyectar o entregar a tus alumnos. Desde la prehistoria hasta el mundo contemporáneo, cada período histórico ordenado y ubicado para visualizar el recorrido completo de la historia.', 'Lo ven, lo entienden y lo ubican en el tiempo.']];
export function BonusSection() {
  return <section className="border-y border-dark-border bg-dark-card px-4 py-20" data-id="element-16">
      <div className="mx-auto max-w-5xl" data-id="element-17">
        <header className="mb-14 text-center" data-id="element-18">
          <p className="text-sm font-bold uppercase tracking-[.2em] text-gold" data-id="element-19">
            Incluidos sin costo extra
          </p>
          <h2 className="mt-2 font-serif text-4xl font-bold" data-id="element-20">
            Los 4 Bonos Estratégicos
          </h2>
        </header>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-21">
          {bonuses.map(([id, title, value, desc, benefit], i) => <motion.article initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} key={id} className="relative rounded-2xl border border-gold/20 bg-black p-7" data-id="element-22">
              <span className="absolute right-0 top-0 rounded-bl-xl border-b border-l border-gold/20 bg-gold/10 px-4 py-2 text-xs font-bold text-gold" data-id="element-23">
                BONO {id}
              </span>
              <Gift className="mb-5 rounded-full bg-gold/20 p-3 text-gold" size={48} data-id="element-24" />
              <h3 className="pr-12 font-serif text-xl font-bold" data-id="element-25">{title}</h3>
              <p className="my-4 inline-block rounded bg-white/5 px-3 py-1 text-sm text-gray-400" data-id="element-26">
                Valor real: <s data-id="element-27">USD {value}</s>{' '}
                <b className="ml-2 text-gold" data-id="element-28">→ GRATIS</b>
              </p>
              <p className="text-sm leading-relaxed text-gray-300" data-id="element-29">{desc}</p>
              <p className="mt-5 text-sm font-medium italic text-gold-light" data-id="element-30">
                {benefit}
              </p>
            </motion.article>)}
        </div>

        <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-gold/30 bg-gold/10 p-8 text-center" data-id="element-31">
          <p className="text-gray-300" data-id="element-32">Valor total de los 4 bonos</p>
          <s className="text-2xl text-gray-500" data-id="element-33">USD 46,00</s>
          <p className="mt-3" data-id="element-34">Tu precio hoy</p>
          <p className="mt-1 text-4xl font-bold text-gold-gradient" data-id="element-35">GRATIS</p>
        </div>

        <CountdownTimer data-id="element-36" />
      </div>
    </section>;
}